@if (spinner) {
<app-spinner></app-spinner>
}

<div class="inner-page-header">
  <h3>{{ pageTitle }}</h3>
</div>

<div class="request-control" #goUp>
  <div class="right-side">
    <!-- Filter Component -->
    @if (filterData) {
    <app-filter
      [filterData]="filterData"
      [filterDataInit]="filterDataInit"
      [filterPage]="filterPage"
      (formValus)="filterFormValues($event)"
    >
    </app-filter>
    }
        
    <!-- Quick Search -->
    <quick-search
      [placeholder]="'ابحث بالعميل ، اسم الوحدة ، رقم التعريف'"
      (searchResults)="quickSearch($any($event))"
    ></quick-search>
  </div>
</div>

<!-- Property Units Table -->
@if (propertyUnits.length > 0) {
<div class="request-table">
  <ayen-selected-count
    [itemsPerPage]="currentItemsPerPage"
    [selectedRows]="selectedRowsPK"
    [totalRowsSelected]="isTotalRowsSelected"
    [pageTitle]="pageTitle"
    [totalItems]="config.totalItems"
    (setTotalRowsSelected)="selectTotalRows($any($event))"
  >
  </ayen-selected-count>
  
  <div class="table-responsive property-units-table">
    <ayen-table
      [tableData]="propertyUnitData"
      [paginationConfig]="config"
      [checkboxTitle]="'رقم التعريف'"
      [checkboxKey]="'reference_number'"
      [initialOrdering]="filterParamsUrl?.ordering"
      [openOrderUrl]="true"
      [pageUrl]="'/pages/property-units/'"
      [clickableColumn]="'orders_count'"
      (checkedRow)="getSelectedRow($event)"
      (sortingCol)="toggleSorting($event)"
      (columnClicked)="onOrdersCountClick($event)"
    >
    </ayen-table>
  </div>
</div>
}

<!-- Pagination -->
@if (propertyUnits && propertyUnits.length > 0) {
<ayen-pagination
  [id]="config.id"
  (pageData)="pageChanged($event)"
  (pageSize)="pageSizeChanged($event)"
  [totalCount]="config.totalItems"
  [pageTitle]="pageTitle"
  [itemsPerPage]="config.itemsPerPage"
  (pageChange)="changeToSpecific($event)"
  [currentPage]="config.currentPage"
>
</ayen-pagination>
}

@if (!spinner && propertyUnits.length === 0) {
<div class="no-data">
  <p>لا توجد وحدات عقارية</p>
</div>
}
